import { useInView } from "../../../hooks/useInView";

const radioFeatures = [
  {
    id: 1,
    label: "Hosted by Big Mike!",
    image: "https://framerusercontent.com/images/JRep6i7ZQ26ehOM8GK5k92nM.png",
  },
  {
    id: 2,
    label: "And Favi Chulo!",
    image: "https://framerusercontent.com/images/mFuh3gfFWBz8byhIclP7moVsk.png",
  },
  {
    id: 3,
    label: "Ft. Wrestling Talk",
    image: "https://framerusercontent.com/images/d5LhU03EPYVITI9SutYtbnGYqM.png",
  },
  {
    id: 4,
    label: "& Special Guests!",
    image: "https://framerusercontent.com/images/zQ3Bqf66O4foVfMTir1s9v8iGs.png",
  },
];

export default function RadioSection() {
  const { ref, inView } = useInView();

  return (
    <section
      ref={ref as React.RefObject<HTMLElement>}
      className="bg-white py-16 md:py-24 relative overflow-hidden"
    >
      {/* Subtle dot grid */}
      <div className="absolute inset-0 bg-dot-grid-light pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20 items-start">
          {/* Left: Text */}
          <div
            className={`lg:w-2/5 lg:sticky lg:top-24 anim-hidden ${inView ? "animate-fade-in-left" : ""}`}
          >
            <div className="inline-block border border-gray-300 text-gray-500 font-condensed font-semibold text-xs uppercase tracking-widest px-3 py-1 mb-6">
              Can&apos;t Get Enough Wrestling?
            </div>
            <h2 className="font-condensed font-black text-gray-900 text-4xl md:text-5xl lg:text-6xl uppercase tracking-tight leading-none mb-6">
              Scoop Slam<br />
              <span className="text-orange-500">Radio</span>
            </h2>
            <p className="text-gray-500 text-sm md:text-base leading-relaxed mb-8">
              Pro wrestling &amp; combat sports with Big Mike and Favi Chulo — live every Tuesday at 7 PM PT on BlogTalkRadio. Catch interviews, highlights, and replays anytime.
            </p>
            <a
              href="https://www.youtube.com/@PWA-mr6xd"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-orange-500 hover:bg-orange-600 text-white font-condensed font-bold text-sm uppercase tracking-widest px-7 py-3.5 transition-all duration-200 cursor-pointer whitespace-nowrap group"
            >
              Check Out the Show
              <i className="ri-arrow-right-line transition-transform duration-200 group-hover:translate-x-1" />
            </a>
          </div>

          {/* Right: Staggered image grid */}
          <div className="flex-1 grid grid-cols-2 gap-4">
            {radioFeatures.map((feature, i) => (
              <div
                key={feature.id}
                className={`relative overflow-hidden group cursor-pointer anim-hidden ${inView ? "animate-scale-in" : ""}`}
                style={{ animationDelay: `${i * 100}ms` }}
              >
                <div className="w-full aspect-[3/4] overflow-hidden bg-gray-100">
                  <img
                    src={feature.image}
                    alt={feature.label}
                    className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-110"
                    style={{ transition: "transform 0.7s cubic-bezier(0.22, 1, 0.36, 1)" }}
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-transparent to-transparent" />
                {/* Orange bottom bar */}
                <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-orange-500 scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left" />
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <p className="font-condensed font-black text-white text-lg uppercase tracking-wide group-hover:text-orange-400 transition-colors duration-200">
                    {feature.label}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
